@for (field of field.fieldGroup; track field; let i = $index) {
  <div class="margin-uchod-1em">
    <div class="flex-container">
      <div fxFlex="50%" style="line-height: 36px;">
        <fa-icon [icon]="to.eicon"></fa-icon> {{ to.teitl | translate }} - {{ i + 1 }}
      </div>
      <div fxFlex="50%">
        <button mat-raised-button style="float: right;" class="margin-chwith-1em" color="warn" type="button"
        (click)="remove(i)">{{ to.labelDileu | translate }}</button>
      </div>
    </div>
    <div class="margin-uchod-1em">
      <formly-field class="col" [field]="field"></formly-field>
    </div>
  </div>
}

<button mat-raised-button class="botwm-ychwanegu" color="primary" type="button"
(click)="add()">{{ to.labelYchwanegu | translate }}</button>